import useAuthStore from "../store/authStore";

const useAuth = () => useAuthStore();

export default useAuth;
